import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChatbotFunService } from 'src/app/services/chatbot-fun.service';

@Component({
  selector: 'app-rate-flow',
  templateUrl: './rate-flow.component.html',
  styleUrls: ['./rate-flow.component.css']
})
export class RateFlowComponent implements OnInit {

  @Output() suggestionMsgEv = new EventEmitter<any>();
  @Input() message: any;
  @Input() intentName: any;
  @Input() isMessageSent: any;
  @Input() rateSuggestion: any;
  @Input() ratingAlignmentAR: any;
  @Input() ratingAlignmentEN: any;
  sessionAttributes:any;
  selectedRating: number = 0;
  lowRate: boolean = false;
  customerIssue: string = '';

  constructor(public chatbotFunService: ChatbotFunService) { }

  ngOnInit() {
  }

  sendMessage1(message, divId, slotToElicit,textContent, name, textTitle,sessionAttributes) {

    const suggestionMsgDetails = {
      message,
      divId,
      slotToElicit,
      sessionAttributes:{
        ratingValue:this.selectedRating.toString(), customerReview:this.customerIssue
       },
      textContent,
      textTitle
    };

    console.log('Message Sent:', suggestionMsgDetails);

    this.suggestionMsgEv.emit(suggestionMsgDetails);
  }

  setSelectedRating(rating: number) {
    if (rating < 3) {
      this.lowRate = true;
    }else{
      this.lowRate = false;
    }
    this.selectedRating = rating;
  }

  onEnterKey() {
  console.log('customerIssue ---> ', this.customerIssue);
  }

}
